// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"idt-sizeattributedropdown_dropdown__27xt4","active":"idt-sizeattributedropdown_active__3v2ts"};